module.exports = __webpack_public_path__ + "img/education.1d9778b4.png";